import { AcceptTermModel } from './../../domain/accept-term/accept-term.model';
import { Observable } from 'rxjs';
export abstract class AcceptTermRepositories {
  abstract getAcceptTerm(type: {}): Observable<AcceptTermModel>;

  abstract postAcceptTerm(type: {}): Observable<AcceptTermModel>;
}
